import React, { useEffect, useState } from "react";
import { Button, Col, Row, Space, Table } from "antd";
import type { TableProps } from "antd";
import { WarningOutlined } from "@ant-design/icons";
import * as String from "../commons/string";

import styles from "./DataTable.module.css";

function DataTable({
    hasScroll,
    loading,
    columns,
    dataSource,
    rowKey,
    onRowKey,
    onSelected,
    onRow,
    defaultSelectedRowKeys,
    onChange,
    tableSize,
}: {
    hasScroll?: boolean;
    loading?: boolean;
    columns: any;
    dataSource: any;
    rowKey?: string;
    onRowKey?: (record: any) => string;
    onSelected?: (values: any, selectedRowKeys: React.Key[]) => void;
    onRow?: (values: any) => void;
    defaultSelectedRowKeys?: Array<string>;
    onChange?: TableProps<any>["onChange"];
    tableSize?: number;
}) {
    const [check, setCheck] = useState<Array<string> | React.Key[]>();
    const [selectedRow, setSelectedRow] = useState<number>();

    useEffect(() => {
        setCheck(defaultSelectedRowKeys);
    }, [defaultSelectedRowKeys]);

    return (
        <Table
            className={onRow !== undefined ? `${styles.table} ${styles.pointerTable}` : `${styles.table}`}
            rowClassName={(record, index) => (index === selectedRow ? styles.selectedRow : "")}
            loading={loading}
            pagination={{
                pageSize: tableSize,
                position: ["bottomCenter"],
                simple: true,

                showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} `,
            }}
            rowSelection={
                onSelected === undefined
                    ? undefined
                    : {
                          type: "checkbox",
                          onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
                              onSelected !== undefined && onSelected(selectedRows, selectedRowKeys);
                              setCheck(selectedRowKeys);
                          },
                          selectedRowKeys: check,
                      }
            }
            rowKey={rowKey ? rowKey : onRowKey ? (record) => onRowKey(record) : undefined}
            columns={columns}
            dataSource={dataSource}
            scroll={hasScroll ? { y: 1500 } : undefined}
            onRow={(record, index) => {
                return {
                    onClick: () => {
                        setSelectedRow(index);
                        onRow !== undefined && onRow(record);
                    },
                };
            }}
            onChange={onChange}
        />
    );
}

export default DataTable;
